export const formatINR = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "0";
  return value.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};
